<section class="h-full flex flex-col overflow-hidden">
  @if(selectedAction.clickAction !== 'SETTING'){
    <div class="flex items-center justify-between p-2 border-b border-[#EAECF0]">
      <p class="text-[13px] text-[#475467] font-semibold pt-2 pl-2">
        {{ selectedAction?.label }}
        @if(selectedAction.clickAction === 'INSIGHTS'){
          <button (click)="reGenerateInsights()" class="p-2" [title]="'Regenerate Insights'">
            <ui-icon name="reload"
                class="stroke-[2px] stroke-[#5D5D5D] hover:stroke-[#0F49A0]"></ui-icon>
          </button>
        }
      </p>
      <ui-icon
        name="rounded-close"
        class="stroke-[#475467] stroke-2 cursor-pointer pt-2"
        size="size-4"
        (click)="closeActionModal()"
      />
    </div>
  }

  <div class="flex-grow min-h-0 overflow-auto">
    @switch (selectedAction.clickAction) { @case ("SAVE") {
    @if(saveReportLoading){
    <div class="flex flex-col justify-center items-center h-full">
      <app-loader [loadingText]="'Saving report..'" />
    </div>
    }@else{ @if (saveReportSuccessful()) {
    <div
      class="flex items-start justify-between mt-4 p-4 border border-[#6CE9A6] rounded-lg bg-[#F6FEF9] mx-4"
    >
      <div class="flex items-center">
        <img src="assets/icons/rounded-check.svg" alt="" />
        <div class="mx-4 text-[#027A48]">
          <p class="text-sm">
            Report {{ isSavedReport ? "updated" : "saved" }} successfully.
          </p>
        </div>
      </div>

      <div (click)="toggleSaveReportSuccessful()" class="cursor-pointer p-1">
        <img src="assets/icons/close.svg" alt="" />
      </div>
    </div>
    } @if (saveReportError()) {
    <div
      class="flex items-start justify-between my-4 p-4 border border-[#FDA29B] rounded-lg bg-[#FFFBFA] mx-4"
    >
      <img src="assets/icons/alert.svg" alt="" />
      <div class="mx-4 text-[#B42318]">
        <p class="text-sm">
          We could not {{ isSavedReport ? "update" : "save" }} this report. Please
          try again.
        </p>
      </div>

      <div (click)="toggleSaveReportError()" class="cursor-pointer p-1">
        <img src="assets/icons/close.svg" alt="" />
      </div>
    </div>
    }
    <div class="flex flex-col justify-start">
      <div class="mx-4">
        <p class="py-3 text-[#344054] text-sm font-semibold">Report Name</p>
        <input
          class="border-2 p-2 rounded-lg w-full"
          [(ngModel)]="reportName"
          [ngClass]="{ 'border-red-500': isReportNameEmpty && !reportName }"
        />
        <p *ngIf="isReportNameEmpty && !reportName" class="text-red-500 mt-2">
          Scope name is required.
        </p>
        <p class="py-3 text-[#344054] text-sm font-semibold">Description</p>
        <textarea
          rows="2"
          class="resize-none border-2 p-4 rounded-lg w-full"
          [(ngModel)]="reportDescription"
          [ngClass]="{ 'border-red-500': isDescriptionEmpty && !reportDescription }"
        ></textarea>
        <p
          *ngIf="isDescriptionEmpty && !reportDescription"
          class="text-red-500 mt-2"
        >
          Description is required.
        </p>
        <p class="py-3 text-[#344054] text-sm font-semibold">Tags</p>
        <div
          class="flex-wrap flex items-center border-2 p-4 rounded-lg w-full bg-gray-100"
        >
          <div
            *ngFor="let tag of tags"
            class="flex items-center px-2 py-1 m-2 bg-white rounded-lg border-2"
          >
            {{ tag }}
            <img
              src="assets/icons/close.svg"
              alt=""
              class="ml-2 mr-1 cursor-pointer"
              (click)="removeTag(tag)"
            />
          </div>
          <input
            class="tag-input bg-gray-100"
            placeholder="Add a tags..."
            [(ngModel)]="tagInput"
            (keydown)="onKeydown($event)"
          />
        </div>
      </div>
      <div class="w-full mt-4 mb-4 border-t border-[#EAECF0] pt-4 bg-white">
        <p
          *ngIf="loadingAction(); else showSaveButton"
          class="text-center w-full mb-2"
        >
          Redirecting to saved report in
          <span class="font-bold text-[#0F49A0]">{{ redirectTime }}s</span>
        </p>
        <ng-template #showSaveButton>
          <button
            [disabled]="isReportNameEmpty"
            class="w-[90%] ml-[5%] text-sm border border-[#D0D5DD] rounded-lg py-2 bg-[#0F49A0] text-white font-bold disabled:bg-[#D0D5DD] disabled:text-[#7D7676] disabled:cursor-not-allowed"
            (click)="onSaveReport()"
          >
            {{ isSavedReport ? "Update report" : "Save Report" }}
          </button>
          @if(isSavedReport) {
            <button
              [disabled]="isReportNameEmpty"
              class="w-[90%] ml-[5%] mt-2 text-sm border border-[#D0D5DD] rounded-lg py-2 bg-white text-[#0F49A0] font-bold disabled:bg-[#D0D5DD] disabled:text-[#7D7676] disabled:cursor-not-allowed"
              (click)="onSaveAsReport()"
            >
              Make a copy
            </button>
          }
        </ng-template>
      </div>
    </div>

    } } @case("SHARE"){
      <div class="h-full">
        <app-export-data
        [defaultFileName]="reportTemplate.name || 'exported_report'"
        [reportVisualType]="reportVisualType"
        [showHeader]="false"
        [hasChartData]="true"
        (switchToChartView)="onSwitchToChartView()">
      </app-export-data>
      </div>
    } @case("COPILOT"){
    <div class="h-full">
      <app-copilot-modal 
      [reportData]="reportVisualData" 
      [templateId]="isSavedReport
      ? this.reportTemplate.parameters.templateId
      : this.reportTemplateId" 
      [selectedScope]="selectedScope.id"
      [isSavedReport]="isSavedReport"
      [conversations]="conversations"
      [reportDetails]="reportDetails"
      (emitConversations)="onConversations($event)"
      [handleApiInParent]="true"
      (askQuestion)="onAskQuestion($event)"
      ></app-copilot-modal>
    </div>
    } @case("INSIGHTS") {
    <div class="h-full overflow-hidden">
      <div class="h-[90%] overflow-auto px-4 pt-2">
        @if(loadingInsights) {
          <div class="flex justify-center items-center h-full">
            <app-loader [loadingText]="'Generating insights...'" />
          </div>
        } @else {
          @if(insights) {
            @for(insight of insights; track $index){
              <div class="rounded-[15px] border-2 p-5 relative mb-2">
                <div class="flex justify-between items-start mb-2">
                  <span class="text-xs text-gray-400 absolute top-3 right-5">
                    {{ insight.timestamp ? (insight.timestamp | date:'short') : 'Just now' }}
                  </span>
                </div>
                <div>
                  <markdown [data]="insight.content" class="prose prose-slate"></markdown>
                </div>
              </div>
            }
          } @else {
            <div class="text-center text-gray-500 mt-8">
              No insights available
            </div>
          }
        }
      </div>
    </div>
    } @case("SETTING"){
      <div class="h-full flex items-center justify-center text-gray-500">
        <p>AG Grid chart settings are managed through the chart editor</p>
      </div>
    } 
  }
  </div>
</section>
